import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="footer-wrap">
    <div className="container">
      <div className="row g-5 mb-5">
        <div className="col-lg-4">
          <div className="nav-logo mb-4">Cegon Soft Tech</div>
          <p style={{ color:'var(--muted)', fontSize:'0.85rem', lineHeight:1.9, fontWeight:300, maxWidth:300 }}>
            A boutique technology studio in Chennai — crafting precise, intentional digital products that endure.
          </p>
          <div className="d-flex gap-3 mt-4">
            {['𝕏','in','f','⚙'].map((ic,i) => (
              <a key={i} href="#!" style={{ width:36, height:36, border:'1px solid var(--border)', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--muted)', fontSize:'0.9rem', transition:'all 0.3s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='var(--tan)'; e.currentTarget.style.color='var(--tan)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.color='var(--muted)'; }}>
                {ic}
              </a>
            ))}
          </div>
        </div>

        <div className="col-lg-2 col-md-4">
          <div style={{ fontFamily:'var(--font-body)', fontSize:'0.65rem', letterSpacing:'0.25em', textTransform:'uppercase', color:'var(--tan)', marginBottom:'1.2rem' }}>Navigation</div>
          {[['/',  'Home'],['/ about','About'],['/development','Development'],['/portfolio','Portfolio'],['/contact','Contact']].map(([p,l]) => (
            <Link key={p} to={p} style={{ display:'block', color:'var(--muted)', fontSize:'0.85rem', marginBottom:10, transition:'color 0.2s', fontWeight:300 }}
              onMouseEnter={e=>e.target.style.color='var(--cream2)'}
              onMouseLeave={e=>e.target.style.color='var(--muted)'}>{l}</Link>
          ))}
        </div>

        <div className="col-lg-3 col-md-4">
          <div style={{ fontFamily:'var(--font-body)', fontSize:'0.65rem', letterSpacing:'0.25em', textTransform:'uppercase', color:'var(--tan)', marginBottom:'1.2rem' }}>Services</div>
          {['MERN Stack','Full Stack Java','Python Dev','Flutter Apps','Digital Marketing','Cyber Security'].map(s => (
            <a key={s} href="#!" style={{ display:'block', color:'var(--muted)', fontSize:'0.85rem', marginBottom:10, fontWeight:300 }}>{s}</a>
          ))}
        </div>

        <div className="col-lg-3 col-md-4">
          <div style={{ fontFamily:'var(--font-body)', fontSize:'0.65rem', letterSpacing:'0.25em', textTransform:'uppercase', color:'var(--tan)', marginBottom:'1.2rem' }}>Contact</div>
          {[['📍','2,Aranya Square,Papanackien Palayam,Coimbatore-641044.'],['📞','+91 7397028889'],['📧','hello@Cegon Soft Tech.in'],['🕐','Mon–Sat  9AM – 7PM']].map(([ic,val],i) => (
            <div key={i} style={{ display:'flex', gap:10, marginBottom:14 }}>
              <span style={{ flexShrink:0 }}>{ic}</span>
              <span style={{ color:'var(--muted)', fontSize:'0.82rem', lineHeight:1.7, fontWeight:300, whiteSpace:'pre-line' }}>{val}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ borderTop:'1px solid var(--border)', paddingTop:28, display:'flex', flexWrap:'wrap', justifyContent:'space-between', gap:12 }}>
        <span style={{ color:'var(--muted)', fontSize:'0.78rem' }}>© 2025 Cegon Soft Tech Technologies. All rights reserved.</span>
        <div className="d-flex gap-4">
          {['Privacy Policy','Terms of Service','Sitemap'].map(t => (
            <a key={t} href="#!" style={{ color:'var(--muted)', fontSize:'0.78rem', transition:'color 0.2s' }}
              onMouseEnter={e=>e.target.style.color='var(--tan)'}
              onMouseLeave={e=>e.target.style.color='var(--muted)'}>{t}</a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
